
export default ({ day, month, year }, context) => {
	return {
		type: "date",
		value: new Date(year, month - 1, day).getTime(),
		primitive: true
	};
};